import { useLocation, useParams } from 'react-router';
import { useSession } from '@/stores/session';
import { NoAccess } from './ListParts';
import { ShipmentDetail } from './ShipmentDetail';
import type { ShipmentListItem } from './types';

/** /shipments/:no —— 路径参数是批次号（老系统没有按 id 取批次的接口，批次号唯一且能搜） */
export function ShipmentDetailPage() {
  const { no = '' } = useParams();
  const seed = (useLocation().state as { seed?: ShipmentListItem } | null)?.seed;
  const can = useSession((st) => st.can);
  if (!can('shipments.read')) return <NoAccess what="发货" legacy="/shipments" />;
  return <ShipmentDetail key={no} no={no} seed={seed} />;
}
